import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import { color } from "rizzo-next/sass/settings.json";
import propTypes from "backpack-ui/dist/utils/propTypes";
import Icon from "../icon";
import { blueLink } from "../../utils/mixins";
import schema from "../../utils/schema";

const styles = {
  container: {
    base: {
      color: color.lightText,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: 1,
    },
  },

  item: {
    padded: {
      marginRight: `${10 / 14}em`,
    },
  },

  anchor: {
    base: blueLink(),

    padded: {
      marginRight: `${10 / 14}em`,
    },
  },
};

const listMicroData = schema({
  itemType: "BreadcrumbList",
});

const itemMicroData = schema({
  itemProp: "itemListElement",
  itemType: "ListItem",
});

/**
 * Breadcrumb navigation component
 */
function Breadcrumbs({ links, style }) {
  const items = links.map((link, index) => (
    <span
      className="Breadcrumbs-item"
      style={[index !== links.length - 1 && styles.item.padded]}
      key={index}
      {...itemMicroData}
    >
      <a
        style={[
          styles.anchor.base,
          index < links.length - 1 && styles.anchor.padded,
        ]}
        href={`https://www.lonelyplanet.com${link.href}`}
        key={index}
        itemProp="item"
      >
        <span itemProp="name">{link.title}</span>
      </a>

      {index < links.length - 1 &&
        <Icon
          name="chevron-right"
          dimensions={{
            width: `${6 / 14}em`,
            height: `${6 / 14}em`,
          }}
        />
      }

      <meta itemProp="position" content={index + 1} />
    </span>
  ));

  return (
    <nav
      className="Breadcrumbs"
      style={[styles.container.base, style]}
      {...listMicroData}
    >
      {items}
    </nav>
  );
}

Breadcrumbs.propTypes = {
  /**
   * An array of links for the navigation
   */
  links: PropTypes.array.isRequired,

  /**
   * Style object to add or override container styles
   */
  style: propTypes.style,
};

Breadcrumbs.defaultProps = {
  links: [],
};

Breadcrumbs.styles = styles;

export default radium(Breadcrumbs);



// WEBPACK FOOTER //
// ./assets/pois/components/breadcrumbs/index.jsx